import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { ICommonLocation } from '../../../common/utils/location/types'
import { IItem } from '../../../typings/searchResults'
import SearchResultsBody from '../../pages/search/result/searchResultBody'

import * as styles from './heroItemSection.module.css'

interface IProps {
  item: IItem
  location: ICommonLocation
  currentSite: Site
  viewType?: string
}

const HeroItemSection = ({
  item,
  location,
  currentSite,
  viewType = 'list'
}: IProps) => {
  const matches = [item]
  const photoDuneClass =
    currentSite === Site.photodune ? styles.photoHeroSection : ''
  return (
    <div className={styles.root}>
      <div className={`${styles.v1HeroSection} ${photoDuneClass}`}>
        <SearchResultsBody
          location={location}
          matches={matches}
          viewType={viewType}
        />
      </div>
    </div>
  )
}

export default HeroItemSection
